import { PropsWithChildren, ReactNode, useState } from 'react'
import css from './mdmListGroup.module.css'
import ArrowDown from '@/assets/icons/arrowDown.svg?react'
import SmoothDropdown from '@/shared/Animated/SmoothDropdown/SmoothDropdown.tsx'
import cn from '@/utils/cn.ts'
import { AnyObject } from '@/global.types.ts'
import SeparateLine from '@/shared/Forms/SeparateLine'
import DropdownUnderThreeDots from '@/shared/Dropdowns/DropdownUnderThreeDots'
import useDropdownUnderIconCtrl from '@/shared/Dropdowns/hooks/useDropdownUnderIconCtrl.ts'

interface ObjectWithName extends AnyObject {
  name: string
}

interface IProps<T extends ObjectWithName> {
  object: T
  icon: ReactNode
  menuOptions: ReactNode
  renderSeparateLine?: boolean
}

const MDMListGroup = <T extends ObjectWithName>(props: PropsWithChildren<IProps<T>>) => {
  const threeDotsMenuCtrl = useDropdownUnderIconCtrl()
  const [open, setOpen] = useState(false)

  return (
    <>
      <div>
        <div
          className={cn('inline-flex-gap gap16 center flex-space-between', css.wrapper)}
          onClick={() => setOpen((prev) => !prev)}
          onContextMenu={(ev) => {
            ev.stopPropagation()
            ev.preventDefault()

            threeDotsMenuCtrl.setOpen(true)
          }}
        >
          <div className="inline-flex-gap gap16 center">
            <ArrowDown data-open={open} className={css.arrow} />
            {props.icon}
            <p className="text-nm">{props.object.name}</p>
          </div>
          {props.menuOptions && (
            <DropdownUnderThreeDots
              open={threeDotsMenuCtrl.open}
              setOpen={threeDotsMenuCtrl.setOpen}
              ref={threeDotsMenuCtrl.ref}
              position="left"
              style={{ overflow: 'visible' }}
            >
              {props.menuOptions}
            </DropdownUnderThreeDots>
          )}
        </div>
        <SmoothDropdown open={open}>
          <div className={css.childWrapper}>{props.children}</div>
        </SmoothDropdown>
      </div>
      {props.renderSeparateLine && !open && <SeparateLine />}
    </>
  )
}

export default MDMListGroup
